export default "__VITE_ASSET__6pJgNNsE__"